import { Directive, ElementRef, inject, Input, Renderer2 } from '@angular/core';
import { ThemeService } from '../utils/theme-service.service';
import { E_ThemeOption } from '../enums/themes.enum';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BehaviorSubject, combineLatest, filter } from 'rxjs';

@Directive({
  selector: '[switchThemeLogo]',
  standalone: false,
})
export class SwitchThemeLogoDirective {
  private el = inject(ElementRef);
  private renderer = inject(Renderer2);
  private themeService = inject(ThemeService);

  // Subject para manejar el flujo de los logos
  private logoPaths$ = new BehaviorSubject<I_ThemeLogos | null>(null);

  @Input('switchThemeLogo') set logoPaths(val: I_ThemeLogos) {
    this.logoPaths$.next(val);
  }

  constructor() {
    combineLatest({
      theme: this.themeService.getTheme().pipe(takeUntilDestroyed()),
      logos: this.logoPaths$.pipe(filter(l => !!l)) // Solo continúa si hay logos
    })
    .pipe(takeUntilDestroyed())
    .subscribe(({ theme, logos }) => {
      const themeToApply = this.resolveTheme(theme);
      const selectedPath = logos[themeToApply as keyof I_ThemeLogos];

      if (selectedPath) {
        this.renderer.setAttribute(this.el.nativeElement, 'src', selectedPath);
      }
    });
  }

  private resolveTheme(theme: E_ThemeOption): E_ThemeOption {
    if (theme === E_ThemeOption.System) {
      return window.matchMedia('(prefers-color-scheme: dark)').matches
        ? E_ThemeOption.Dark
        : E_ThemeOption.Light;
    }
    return theme;
  }
}
interface I_ThemeLogos {
  [E_ThemeOption.Light]: string,
  [E_ThemeOption.Dark]: string
}
